var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 74,
    viewBox: "0 0 80 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3351",
    "data-name": "Rectangle 3351",
    width: 52.28,
    height: 52.295,
    fill: "#5e84c3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14355",
    "data-name": "Group 14355",
    transform: "translate(-454 -887)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(454 887)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14340",
    "data-name": "Group 14340",
    transform: "translate(-472.736 -300.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3350",
    "data-name": "Rectangle 3350",
    transform: "translate(942.736 1197.736)",
    fill: "#5e84c3",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14339",
    "data-name": "Group 14339",
    transform: "translate(948.736 1203.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14338",
    "data-name": "Group 14338",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42149",
    "data-name": "Path 42149",
    d: "M0,231.949c.172-.931.284-1.878.526-2.79a17.006,17.006,0,0,1,9.813-11.733.7.7,0,0,1,.817.1,12.466,12.466,0,0,0,8.729,2.462,12.2,12.2,0,0,0,6.386-2.453.729.729,0,0,1,.906-.1c.992.545,2,1.066,3.1,1.649-.974.686-1.82,1.279-2.664,1.876a1.788,1.788,0,0,0-.5,2.831c.344.506.7,1.005,1.025,1.523a.523.523,0,0,1,.033.435c-.039.08-.254.123-.378.1-.7-.109-1.4-.262-2.108-.361a1.593,1.593,0,0,0-1.9,1.289c-.369,1.83-.706,3.668-1,5.511a1.608,1.608,0,0,0,1.374,1.937c.662.147,1.335.245,2,.392a.533.533,0,0,1,.339.284c.032.088-.079.279-.179.355-.527.4-1.075.777-1.609,1.17a1.737,1.737,0,0,0-.462,2.581c.521.776,1.049,1.546,1.615,2.379H9.368c0-1.494,0-3.012,0-4.53,0-.716-.279-1.057-.826-1.047-.52.009-.781.351-.782,1.033,0,1.259,0,2.519,0,3.778,0,.25.048.5.081.826H0v-9.5",
    transform: "translate(0 -194.361)",
    fill: "#5e84c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42150",
    "data-name": "Path 42150",
    d: "M242.331,252.538q-1.792-.359-3.585-.717c-.383-.076-.767-.15-1.153-.206-.412-.06-.594-.226-.5-.686.184-.88.308-1.773.473-2.657a.644.644,0,0,0-.36-.757,7.865,7.865,0,0,1-.942-.6.685.685,0,0,0-.924,0c-.695.49-1.4.965-2.105,1.439-.163.11-.347.189-.547.3-1.061-1.577-2.093-3.114-3.13-4.648-.2-.292,0-.438.2-.581.687-.5,1.369-1.01,2.071-1.489a.789.789,0,0,0,.363-1,4.263,4.263,0,0,1-.136-.595c-.163-.93-.161-.934-1.065-1.122-.748-.155-1.495-.318-2.249-.437-.339-.053-.425-.186-.367-.5q.462-2.53.9-5.064c.078-.45.339-.535.736-.455.8.161,1.6.3,2.4.466a.74.74,0,0,0,.95-.455,2.924,2.924,0,0,1,.454-.735.842.842,0,0,0-.005-1.188c-.5-.69-.938-1.418-1.426-2.114a.409.409,0,0,1,.12-.674q2.05-1.42,4.092-2.849c.331-.232.557-.209.789.156.455.718.96,1.4,1.424,2.116a.713.713,0,0,0,.9.357,6.286,6.286,0,0,1,1-.2.736.736,0,0,0,.707-.676c.134-.8.282-1.605.419-2.408.11-.643.2-.719.825-.607,1.537.277,3.071.564,4.609.835.456.08.64.264.522.765-.187.792-.3,1.6-.45,2.4a.784.784,0,0,0,.5,1.026,2.1,2.1,0,0,1,.475.3c.8.594.79.526,1.6-.016l2.259-1.519c.13.182.23.316.323.455.907,1.357,1.8,2.723,2.726,4.067.232.338.182.534-.132.75-.7.48-1.386.985-2.091,1.46a.744.744,0,0,0-.373.981,4.853,4.853,0,0,1,.2,1.047.674.674,0,0,0,.632.623q1.2.216,2.406.429c.624.109.73.274.614.906-.288,1.57-.582,3.138-.842,4.713-.075.45-.282.571-.7.491-.833-.161-1.672-.3-2.5-.47a.667.667,0,0,0-.837.382,3.669,3.669,0,0,1-.479.78.874.874,0,0,0,.007,1.266c.485.655.9,1.359,1.374,2.026a.457.457,0,0,1-.14.757q-2.064,1.41-4.112,2.843c-.289.2-.474.174-.668-.119-.478-.724-.986-1.427-1.455-2.156a.745.745,0,0,0-.992-.356,1.1,1.1,0,0,1-.4.089c-.96-.031-1.281.518-1.357,1.382a16.729,16.729,0,0,1-.331,1.854,4.987,4.987,0,0,1-.206.613Zm.149-20.455a6.049,6.049,0,1,0,5.949,6.066,6.011,6.011,0,0,0-5.949-6.066",
    transform: "translate(-204.235 -200.243)",
    fill: "#5e84c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42151",
    "data-name": "Path 42151",
    d: "M79.765,0A11.511,11.511,0,0,1,90.476,7.732a12.374,12.374,0,0,1-4.209,14.22,11.16,11.16,0,0,1-15.711-2.671A12.342,12.342,0,0,1,74.133,1.529,10.758,10.758,0,0,1,79.765,0",
    transform: "translate(-61.019 0)",
    fill: "#5e84c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42152",
    "data-name": "Path 42152",
    d: "M327.39,319.051a4.654,4.654,0,0,1-4.648,4.632,4.693,4.693,0,0,1,.12-9.384,4.651,4.651,0,0,1,4.528,4.751",
    transform: "translate(-284.584 -281.099)",
    fill: "#5e84c3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDProfile);
export default __webpack_public_path__ + "static/media/d-profile.e78f9548964660e3f64bdeec00d458d6.svg";
export { ForwardRef as ReactComponent };